import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!localStorage.getItem("ht_cookie_notice")) setShow(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem("ht_cookie_notice", "1");
    setShow(false);
  };

  if (!show || pathname === "/cookies") return null;

  return (
    <div data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-t border-zinc-200 animate-fade-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6">
        <p className="text-sm text-zinc-600 leading-relaxed flex-1">
          <span className="font-semibold text-zinc-950">A quick word on cookies.</span>{" "}
          We only use strictly necessary cookies to keep you signed in. No tracking, no advertising.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <Link to="/cookies" data-testid="cookie-policy-link"
            className="text-xs font-medium text-zinc-600 hover:text-zinc-950 transition-colors duration-200">
            Cookie policy
          </Link>
          <button onClick={dismiss} data-testid="cookie-accept"
            className="bg-zinc-950 text-white text-xs font-semibold px-5 py-2.5 rounded-md hover:bg-zinc-800 transition-colors duration-200">
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
